import React, { useEffect } from 'react';
import { Page } from '@shopify/polaris';
import NewCourseComponent from 'src/components/NewCourse';
import { useNavigate } from '@reach/router';

const NewCourse = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (window.Appcues) {
      window.Appcues.page();
    }
  });

  return (
    <Page
      breadcrumbs={[
        {
          content: 'Courses',
          accessibilityLabel: 'Courses',
          onAction: () => navigate('/home'),
        },
      ]}
      title="Name your course"
      singleColumn
    >
      <NewCourseComponent />
    </Page>
  );
};

export default NewCourse;
